import { logger } from '@gem/modules/logger';

import { addTrustedDevicesToSecretGroup } from 'APP/Tasks/e2ee/addTrustedDevicesToSecretGroup';
import { e2eeModel, userSettingsModel } from 'APP/model/model';
import { DeviceStatus } from 'APP/model/userSettings/userSettingsModel.types';
import Entities from 'STORE';

export const approveTrustedDevice = async (deviceId: string): Promise<{ error: string | null }> => {
  const secretChats = Entities.GroupsStore.groups.filter((group) => group.isSecretGroup);
  let keyPackages = [];
  const keyPackagesResponse = await e2eeModel.getKeyPackagesForUntrustedDevice(
    deviceId,
    secretChats.length
  );
  keyPackages = keyPackagesResponse.keyPackages;

  if (keyPackages.length < secretChats.length) {
    await new Promise<void>((resolve) => setTimeout(resolve, 1000));
    const lastKeyPackages = await e2eeModel.getKeyPackagesForUntrustedDevice(
      deviceId,
      secretChats.length - keyPackages.length
    );
    keyPackages = [...keyPackages, ...lastKeyPackages.keyPackages];
  }

  const promises = keyPackages.map((keyPackage, index) => {
    return addTrustedDevicesToSecretGroup(secretChats[index].id, keyPackage);
  });

  try {
    await Promise.all(promises);
  } catch (error) {
    logger.get('Tasks').error('e2ee.addTrustedDevicesToSecretGroup', error);
  }

  await userSettingsModel.setDeviceStatus({ deviceId, status: DeviceStatus.Trusted });

  return { error: null };
};
